export const hasSidebarPermission = (user, key) => {
    if (!user || !user.userSideBarPermissions) return false;
    return user.userSideBarPermissions.includes(`${key}-in-sidebar_r`);
};